console.log(`Graphistry client library ${process.env.APP_BUILD_TAG}`);

import 'rc-slider/assets/index.css';
import 'rc-switch/assets/index.css';
import 'react-virtualized/styles.css';
import '../bootstrap.scss';
import 'flag-icon-css/css/flag-icon.min.css';
import 'font-awesome/css/font-awesome.css';
import '@graphistry/viz/src/index.less';

require('./startup/setupRxAndRecompose');

import { Scheduler } from '@reactivex/rxjs';
import { container } from '@graphistry/falcor-react-redux';

container.globalDisposeDelay = 5000;
container.globalDisposeScheduler = Scheduler.async;

import React from 'react';
import * as ReactDOM from 'react-dom';
import 'react-hot-loader/patch';
import { Provider } from 'react-redux';
import compose from 'react-recompose/compose';
import { AppContainer } from 'react-hot-loader';

import { configureHMR, hmrRenderLoop } from './configureHMR';
import { congfigureLive } from './live';
import { configureStore } from './store';
//import { setupAnalytics } from './startup/setupAnalytics';
import { getURLParameters } from './startup/getURLParameters';
import { setupLegacyInterop } from './legacy/setupLegacyInterop';
import { setupErrorHandlers } from './startup/setupErrorHandlers';

const store = configureStore();

const { model, socket, ...options } = compose(
    (opts) => congfigureLive(opts),
    //(opts) => setupAnalytics(window, opts),  //SECURITY: Disabled google analytics
    (opts) => setupErrorHandlers(document, window, opts),
    (opts) => configureHMR(window, opts)  // Reverse order: this runs first
)(getURLParameters(window.location.href));

const withLegacyInterop = setupLegacyInterop(document, { ...options, socket, model });

/*
//for testing HMR
function renderApp() {
    console.log('@renderApp simplified (REMOVE)');
    const App = require('@graphistry/viz/src/containers/appStub').App; // eslint-disable-line global-require
    ReactDOM.render(
        <App/>,
        getRootDOMNode()
    );
}
*/

function renderApp() {
    const App = withLegacyInterop(require('@graphistry/viz/src/containers/app').default); // eslint-disable-line global-require
    ReactDOM.render(
        <AppContainer>
            <Provider store={store}>
                <App falcor={model} params={options} key="viz-client" />
            </Provider>
        </AppContainer>,
        getRootDOMNode()
    );
}

if (socket) {
    socket.once('connect', function () {
        renderApp();
    });
} else {
    console.log('Initial render (without socket)');
    renderApp()
}

if (module.hot) {
    hmrRenderLoop(renderApp, getRootDOMNode);
}

function getRootDOMNode(appDomNode) {
    return (appDomNode =
        document.getElementById('root') ||
        document.body.appendChild(
            (appDomNode = document.createElement('div')) && (appDomNode.id = 'root') && appDomNode
        ));
}

document && document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('touchmove', (e) => e.preventDefault(), { passive: false });
    window.scrollTop = 1;
    setTimeout(() => window.scrollTop = 0, 0);
});
